export const iconFontAwesomeSecurityPersonFallingBurst = (
	<i className="fa-solid fa-person-falling-burst"></i>
);
